import config from '../config';
import { handleResponse } from "./builder";

export const pay = (user, card) => fetch(`${config.apiUrl}/payment`, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.id}`
    },
    body: JSON.stringify(card)
}).then(handleResponse)